// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/talkDepositTerms.css
// module id = /NVn
// module chunks = 1